import { render, staticRenderFns } from "./ChatNotification.vue?vue&type=template&id=6eace364&scoped=true&"
import script from "./ChatNotification.vue?vue&type=script&lang=js&"
export * from "./ChatNotification.vue?vue&type=script&lang=js&"
import style0 from "./ChatNotification.vue?vue&type=style&index=0&id=6eace364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eace364",
  null
  
)

export default component.exports